/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { LISTING_STATUS } from './constants/listingStatus';
import { findListingEntity, getListingProductIdFromState } from './helpers/entityReadHelpers';
import { upsertListing } from './helpers/entityAdapter';
import refreshListingAssetsForChannels from './helpers/refreshListingAssetsForChannels';
import { setActiveTabByProductChannel } from './helpers/uiAdapter';

export const discardProductDraft = createAsyncThunk(
  'products/discardProductDraft',
  async ({ productId, channelId }, { dispatch, getState, extra: { sdk } }) => {
    const listingProductId = getListingProductIdFromState(getState().products, productId, channelId);

    if (!listingProductId) {
      throw new Error(`Listing not found for channel ${channelId}`);
    }

    const { data } = await sdk.products.discardDraft(listingProductId);
    const updatedListing = data.listing ?? data;

    await refreshListingAssetsForChannels({
      dispatch,
      getState,
      productId,
      channelIds: [channelId],
      delayMs: 0,
    });

    return { productId, channelId, updatedListing };
  },
);

export const reducer = (builder) => {
  builder
    .addCase(discardProductDraft.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(discardProductDraft.fulfilled, (state, { payload }) => {
      const { productId, channelId, updatedListing } = payload;
      state.isBusy = false;

      const existingListing = findListingEntity(state, { masterProductId: productId, channelId });

      setActiveTabByProductChannel(state, productId, channelId, LISTING_STATUS.PUBLISHED);
      upsertListing(state, {
        ...existingListing,
        ...updatedListing,
        masterProductId: productId,
        listingStatus: LISTING_STATUS.PUBLISHED,
      });
    })
    .addCase(discardProductDraft.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot discard listing draft';
    });
};
